import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface Video3IconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const Video3Icon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick,
}: Video3IconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M19.5569 14.2671V9.73293C19.5569 5.95447 18.0455 4.44308 14.2671 4.44308H9.73293C5.95447 4.44308 4.44308 5.95447 4.44308 9.73293V14.2671C4.44308 18.0455 5.95447 19.5569 9.73293 19.5569H14.2671C18.0455 19.5569 19.5569 18.0455 19.5569 14.2671Z"
                stroke={color}
                strokeWidth={1.51138}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.5896 13.0249C15.1289 13.308 15.1289 14.0801 14.5896 14.3632L10.7369 16.3853C10.2337 16.6494 9.62997 16.2845 9.62997 15.7162L9.62997 11.6719C9.62997 11.1036 10.2337 10.7386 10.7369 11.0028L14.5896 13.0249Z"
                fill={color}
            />
            <path
                d="M4.83606 8.30466H19.164"
                stroke={color}
                strokeWidth={1.51138}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.22156 4.82092L10.4886 8.22153"
                stroke={color}
                strokeWidth={1.51138}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.7557 4.44308L15.0228 8.22154"
                stroke={color}
                strokeWidth={1.51138}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default Video3Icon
